import React from 'react';
import ContactUs from '../../components/ContactUs';

const Contact = () => {
  return (
    <div>
      <ContactUs />
    </div>
  );
};

export default Contact;
